import { Box, Card, CardContent, Divider, Grid, makeStyles, Typography, CardHeader, Button, Chip } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles({
    dividerRoot: {
        margin: "0 1em 0 1em"
    },
    headerAction: {
        margin: "0"
    },
    cardRoot: {
        width: "100%",
        height: "100%"
    },
    cardHover: {
        cursor: "pointer",
        transform: "scale(1)",
        "&:hover, &:active": {
            transition: "all 0.15s ease-in-out",
            transform: "scale(0.99)"
        },
    },
    itemTitle: {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        color: "rgba(0, 0, 0, 0.54)"
    },
    itemValue: {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
    },
    cardHeaderSubheader: {
        textTransform: "uppercase"
    },
});



export default function OrderManagerCard(props) {
    const classes = useStyles();

    return (
        <Card className={`${props.className} ${classes.cardRoot} ${props.hover ? classes.cardHover : ""}`} onClick={props.onClick}>
            <CardHeader
                classes={{ action: classes.headerAction }}
                title={props.title}
                subheader={props.subtitle}
                action={<Chip label={props.status} variant="outlined" />}
                subheaderTypographyProps={{ className: classes.cardHeaderSubheader }}
            />
            <Divider className={classes.dividerRoot} />
            <CardContent>

                {
                    props.displayMessage ?
                        <Typography>{props.displayMessage}</Typography> :
                        <Grid container spacing={1}>
                            {props.data.map(item => {
                                const length = 2 //Math.round(12 / (props.data.length <= 8 ? props.data.length : 8))
                                return <Grid item xs={length}>
                                    <Typography className={classes.itemTitle} variant="subtitle2">
                                        {item.title}
                                    </Typography>
                                    <Typography variant="body1" className={classes.itemValue}>
                                        {item.value || "-"}
                                    </Typography>
                                </Grid>
                            })}
                        </Grid>
                }
            </CardContent>
        </Card>
    )
}